import React from "react";
import { TaskCard } from "./TaskCard";
const TasksList = ({ todosList, todoState }) => {
  return (
    <>
      <h2 className="ml-2 text-xl mt-4 font-semibold font-Indie-Flower tracking-wider">
        {" "}
        📌Your Tasks....🏃
      </h2>
      <div className="overflow-hidden mt-4 p-2 grid md:grid-cols-3 sm:grid-cols-2 lg:grid-cols-4  gap-5">
          {todosList.map((todo, index) => (
            <TaskCard
            key={index}
              todo={todo}
              index={index}
              todoState={todoState}
            />
            
          ))}
          </div>
    </>
  );
};

export default TasksList;
